/* eslint-disable sonarjs/no-duplicate-string */
export const LOYALTY_LABELS = 'global.loyalityBanner';

const LoyaltyBannerLabels = {
  global: {
    loyalityBanner: {
      lbl_loyaltyBanner_estimatedSubtotal:
        'Estimated Subtotal with a My Place Rewards Credit Card: ',
      lbl_loyaltyBanner_currentSubtotal: 'Current Subtotal: ',
      lbl_banner_pdp_guest_rewards_label1: 'GET REWARDED FOR SHOPPING!',
      lbl_banner_pdp_guest_rewards_label2: '$1 SPENT = 1 POINT  |  100 POINTS = $5 REWARD',
      lbl_loyaltyBanner_createAccount: 'Create My Place Reward Account',
      lbl_loyaltyBanner_sectionSymbol: '§',
      lbl_loyaltyBanner_guestConfirmationCreateMyPlaceRewards: 'Create My Place Rewards Account',
      lbl_banner_added2bag_guest_points_label1:
        'YOU CAN EARN #estimatedRewardsVal# POINTS #br# ON THIS PURCHASE!',
      lbl_banner_added2bag_guest_points_label2: '$1 Spent = 1 Point | 100 Points = $5 Reward',
      lbl_banner_added2bag_guest_rewards_label1:
        'BECOME A MEMBER TO GET A #br# #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_added2bag_guest_rewards_label2: '$1 Spent = 1 Point | 100 Points = $5 Reward',
      lbl_banner_added2bag_guest_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_added2bag_mpr_points_label1:
        "You'll earn #estimatedRewardsVal# points on this purchase!",
      lbl_banner_added2bag_mpr_points_label2: 'EARN DOUBLE POINTS EVERY DAY!',
      lbl_banner_added2bag_mpr_points_label3: 'with the MY PLACE REWARDS CREDIT CARD',
      lbl_banner_added2bag_mpr_rewards_label1:
        'YOU’LL EARN #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_added2bag_mpr_rewards_label2: 'EARN DOUBLE POINTS EVERY DAY!',
      lbl_banner_added2bag_mpr_rewards_label3: 'with the MY PLACE REWARDS CREDIT CARD',
      lbl_banner_added2bag_plcc_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS #br# ON THIS PURCHASE!',
      lbl_banner_added2bag_plcc_points_label2:
        'When you check out with your MY PLACE REWARDS CREDIT CARD!',
      lbl_banner_added2bag_plcc_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_added2bag_plcc_rewards_label2:
        'When you check out with your MY PLACE REWARDS CREDIT CARD!',
      lbl_banner_minibag_guest_points_label1:
        'You can earn #estimatedRewardsVal# points on this purchase!',
      lbl_banner_minibag_guest_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_minibag_guest_rewards_label1:
        'Become a member to get a #estimatedRewardsVal# Reward on this purchase!',
      lbl_banner_minibag_guest_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_minibag_mpr_points_label1:
        "You'll earn #estimatedRewardsVal# points on this purchase!",
      lbl_banner_minibag_mpr_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_minibag_mpr_rewards_label1:
        "You'll get a #estimatedRewardsVal# Reward with this purchase!",
      lbl_banner_minibag_mpr_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_minibag_plcc_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_minibag_plcc_points_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_minibag_plcc_points_label3: 'That’s #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_minibag_plcc_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_minibag_plcc_rewards_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_guest_points_label1:
        'You can earn #estimatedRewardsVal# points on this purchase!',
      lbl_banner_bag_guest_points_label2: 'SAVE #plccOfferPercentage#% TODAY! #sectionSymbol#',
      lbl_banner_bag_guest_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_guest_rewards_label1:
        'Become a member to get a #estimatedRewardsVal# Reward #br# on this purchase!',
      lbl_banner_bag_guest_rewards_label2: 'SAVE #plccOfferPercentage#% TODAY!',
      lbl_banner_bag_guest_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_mpr_points_label1:
        "You'll earn #estimatedRewardsVal# points on this purchase!",
      lbl_banner_bag_mpr_points_label2: 'SAVE #plccOfferPercentage#% TODAY! #sectionSymbol#',
      lbl_banner_bag_mpr_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_mpr_rewards_label1:
        "You'll get a #estimatedRewardsVal# Reward with this purchase!",
      lbl_banner_bag_mpr_rewards_label2: 'SAVE #plccOfferPercentage#% TODAY! #sectionSymbol#',
      lbl_banner_bag_mpr_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_plcc_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS #br# ON THIS PURCHASE!',
      lbl_banner_bag_plcc_points_label2:
        'when you check out with your #br# MY PLACE REWARDS CREDIT CARD',
      lbl_banner_bag_plcc_points_label3: 'That’s #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_bag_plcc_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_bag_plcc_rewards_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_guest_points_label1:
        'You can earn #estimatedRewardsVal# points on this purchase!',
      lbl_banner_checkout_guest_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_guest_rewards_label1:
        'Become a member to get a #estimatedRewardsVal# Reward on this purchase!',
      lbl_banner_checkout_guest_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_mpr_points_label1:
        "You'll earn #estimatedRewardsVal# points on this purchase!",
      lbl_banner_checkout_mpr_points_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_mpr_rewards_label1:
        "You'll get a #estimatedRewardsVal# Reward with this purchase!",
      lbl_banner_checkout_mpr_rewards_label3:
        '+ EARN DOUBLE POINTS* when you open & use a MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_plcc_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_checkout_plcc_points_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_checkout_plcc_points_label3:
        'That’s #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_checkout_plcc_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_checkout_plcc_rewards_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_review_guest_points_label1:
        'YOU CAN EARN #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_review_guest_points_label2: '$1 Spent = 1 Point | 100 Points = $5 Reward',
      lbl_banner_review_guest_rewards_label1:
        'BECOME A MEMBER TO GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_review_guest_rewards_label2: '$1 Spent = 1 Point | 100 Points = $5 Reward',
      lbl_banner_review_mpr_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS ON #br# THIS PURCHASE!',
      lbl_banner_review_mpr_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON #br# THIS PURCHASE!',
      lbl_banner_review_plcc_points_label1:
        'YOU’LL EARN #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_review_plcc_points_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_review_plcc_points_label3: 'That’s #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_review_plcc_rewards_label1:
        'YOU’LL GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_review_plcc_rewards_label2:
        'when you check out with your MY PLACE REWARDS CREDIT CARD',
      lbl_banner_confirmation_guest_points_label1:
        'SIGN UP FOR #tagOpen# MY PLACE REWARDS #tagClose# TODAY TO EARN POINTS ON YOUR NEXT PURCHASE!',
      lbl_banner_confirmation_guest_rewards_label1:
        'BECOME A MEMBER TO GET A #estimatedRewardsVal# REWARD ON THIS PURCHASE!',
      lbl_banner_confirmation_guest_rewards_label2: '$1 Spent = 1 Point | 100 Points = $5 Reward',
      lbl_banner_confirmation_mpr_points_label1:
        'YOU EARNED #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_confirmation_mpr_points_label2:
        'That’s #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_confirmation_mpr_rewards_label1:
        'YOU EARNED A #estimatedRewardsVal# REWARD ON TODAY’S PURCHASE!',
      lbl_banner_confirmation_plcc_points_label1:
        'YOU EARNED #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      lbl_banner_confirmation_plcc_points_label2:
        'You’re #pointsToNextReward# points from a $5 Reward.',
      lbl_banner_confirmation_plcc_rewards_label1:
        'YOU EARNED A #estimatedRewardsVal# REWARD ON TODAY’S PURCHASE!',
      lbl_loyaltyBanner_createMyPlaceRewardsAccount: 'Create My Place Rewards Account',
      lbl_freeShippingBanner_label: '#tagOpen# #tagClose# FREE Shipping Every Day!',
      lbl_banner_pdp_mpr_rewards_label1: 'EARN DOUBLE POINTS EVERYDAY!',
      lbl_banner_pdp_mpr_rewards_label3: 'with the My Place Rewards Credit Card',
      lbl_banner_pdp_plcc_rewards_label1: 'EARN DOUBLE POINTS',
      lbl_banner_pdp_plcc_rewards_label2:
        'when you checkout with your My Place Rewards Credit Card',
      lbl_banner_added2bag_guest_link1_action: 'CreateAccountAction',
      lbl_banner_added2bag_guest_link2_text: 'Login',
      lbl_banner_added2bag_guest_link2_action: 'loginAction',
      lbl_banner_added2bag_mpr_link1_action: 'ApplyNowAction',
      lbl_banner_added2bag_mpr_link2_action: 'LearnMoreAction',
      lbl_banner_added2bag_mpr_link2_prefix: '§*',
      lbl_banner_added2bag_plcc_link1_action: 'LearnMoreAction',
      lbl_banner_bag_guest_link1_action: 'ApplyNowAction',
      lbl_banner_bag_guest_link2_prefix: '§*',
      lbl_banner_bag_guest_link2_action: 'LearnMoreAction',
      lbl_banner_bag_mpr_link1_action: 'ApplyNowAction',
      lbl_banner_bag_mpr_link2_prefix: '§*',
      lbl_banner_bag_mpr_link2_action: 'LearnMoreAction',
      lbl_banner_bag_plcc_link1_text: 'Learn More',
      lbl_banner_bag_plcc_link1_action: 'LearnMoreAction',
      lbl_banner_review_plcc_link1_action: 'LearnMoreAction',
      lbl_banner_pdp_guest_link1_action: 'CreateAccountAction',
      lbl_banner_pdp_guest_link2_text: 'Login',
      lbl_banner_pdp_guest_link2_action: 'loginAction',
      lbl_banner_pdp_mpr_link1_action: 'ApplyNowAction',
      lbl_banner_pdp_mpr_link2_action: 'LearnMoreAction',
      lbl_banner_pdp_plcc_link1_action: 'LearnMoreAction',
      lbl_banner_fancy_checkout_save_msg: 'SAVE #off# TODAY!#sectionSymbol#',
      lbl_banner_fancy_checkout_rewards_label:
        'when you open & use a <strong>MY PLACE REWARDS CREDIT CARD</strong>',
      lbl_banner_bag_link_prefix: '§',
      lbl_banner_fancy_checkout_rewards_nonplcc:
        'You can save #estimatedRewardsVal# on this purchase',
      lbl_loyaltyBanner__fancy_estimatedSubtotal: 'Your New Estimated Subtotal With Card: ',
    },
  },
};

export default LoyaltyBannerLabels;
